import ajax from '../../lib/ajax'
// Machines/GetMachineTypeList
// 获取设备类型列表
export async function GetMachineTypeList(payload:any) {
    let res = await ajax.get('api/services/app/Machines/GetMachineTypeList',{params:payload},false)
    return res.data.result
}
// Machines/GetManufacturerList
// 获取维修保养厂商列表
export async function GetManufacturerList(payload:any) {
    let res = await ajax.get('api/services/app/Machines/GetManufacturerList',{params:payload},false)
    return res.data.result
}
// Machines/GetManufacturerDetail
// 获取维修保养厂商详情
export async function GetManufacturerDetail(payload:any) {
    let res = await ajax.get('api/services/app/Machines/GetManufacturerDetail',{params:payload},false)
    return res.data.result
}
// Machines/GetMachineTypeDetail
// 获取设备类型详情
export async function GetMachineTypeDetail(payload:any) {
    let res = await ajax.get('api/services/app/Machines/GetMachineTypeDetail',{params:payload},false)
    return res.data.result
}
// Machines/DeleteMachineScrap
// 删除设备报废条目
export async function DeleteMachineScrap(payload:any) {
    let res = await ajax.delete('api/services/app/Machines/DeleteMachineScrap',{params:payload},false)
    return res.data.result
}
// Machines/InsertMachineType
// 新增设备类型
export async function InsertMachineType(payload:any) {
    let res = await ajax.post('api/services/app/Machines/InsertMachineType', payload,false)
    return res.data.result
}
// Machines/InsertMachine
// 新增设备
export async function InsertMachine(payload:any) {
    let res = await ajax.post('api/services/app/Machines/InsertMachine', payload,false)
    return res.data.result
}
// Machines/InsertManufacturer
// 新增维修保养厂商
export async function InsertManufacturer(payload:any) {
    let res = await ajax.post('api/services/app/Machines/InsertManufacturer', payload,false)
    return res.data.result
}
// Machines/InsertMachineScrap
// 新增设备报废
export async function InsertMachineScrap(payload:any) {
    let res = await ajax.post('api/services/app/Machines/InsertMachineScrap', payload,false)
    return res.data.result
}
// Machines/InsertMachineRepair
// 新增设备维修
export async function InsertMachineRepair(payload:any) {
    let res = await ajax.post('api/services/app/Machines/InsertMachineRepair', payload,false)
    return res.data.result
}
// Machines/InsertMachineMaintenance
// 新增设备保养
export async function InsertMachineMaintenance(payload:any) {
    let res = await ajax.post('api/services/app/Machines/InsertMachineMaintenance', payload,false)
    return res.data.result
}
// Machines/UpdateMachineType
// 更新设备类型
export async function UpdateMachineType(payload:any) {
    let res = await ajax.put('api/services/app/Machines/UpdateMachineType', payload,false)
    return res.data.result
}
// Machines/UpdateManufacturer
// 更新维修保养厂商
export async function UpdateManufacturer(payload:any) {
    let res = await ajax.put('api/services/app/Machines/UpdateManufacturer', payload,false)
    return res.data.result
}
// Machines/UpdateMachine
// 更新设备
export async function UpdateMachine(payload:any) {
    let res = await ajax.put('api/services/app/Machines/UpdateMachine', payload,false)
    return res.data.result
}
// Machines/UpdateMachineScrap
// 更新设备报废信息
export async function UpdateMachineScrap(payload:any) {
    let res = await ajax.put('api/services/app/Machines/UpdateMachineScrap', payload,false)
    return res.data.result
}
// Machines/UpdateMachineRepair
// 更新设备维修
export async function UpdateMachineRepair(payload:any) {
    let res = await ajax.put('api/services/app/Machines/UpdateMachineRepair', payload,false)
    return res.data.result
}
// Machines/UpdateMachineMaintenance
// 更新设备保养
export async function UpdateMachineMaintenance(payload:any) {
    let res = await ajax.put('api/services/app/Machines/UpdateMachineMaintenance', payload,false)
    return res.data.result
}
// Machines/GetMachineList
// 获取设备列表
export async function GetMachineList(payload:any) {
    let res = await ajax.get('api/services/app/Machines/GetMachineList', {params:payload},false)
    return res.data.result
}
// Machines/GetMachineDetail
// 获取设备详情
export async function GetMachineDetail(payload:any) {
    let res = await ajax.get('api/services/app/Machines/GetMachineDetail', {params:payload},false)
    return res.data.result
}
// Machines/GetMachineScrapList
// 获取设备报废列表
export async function GetMachineScrapList(payload:any) {
    let res = await ajax.get('api/services/app/Machines/GetMachineScrapList', {params:payload},false)
    return res.data.result
}
// Machines/GetMachineScrapDetail
// 获取设备报废详情
export async function GetMachineScrapDetail(payload:any) {
    let res = await ajax.get('api/services/app/Machines/GetMachineScrapDetail', {params:payload},false)
    return res.data.result
}
// Machines/GetMachineRepairList
// 获取设备维修列表
export async function GetMachineRepairList(payload:any) {
    let res = await ajax.get('api/services/app/Machines/GetMachineRepairList', {params:payload},false)
    return res.data.result
}
// Machines/GetMachineRepairDetail
// 获取设备维修信息
export async function GetMachineRepairDetail(payload:any) {
    let res = await ajax.get('api/services/app/Machines/GetMachineRepairDetail', {params:payload},false)
    return res.data.result
}
// Machines/GetMachineMaintenanceList
// 获取设备保养列表
export async function GetMachineMaintenanceList(payload:any) {
    let res = await ajax.get('api/services/app/Machines/GetMachineMaintenanceList', {params:payload},false)
    return res.data.result
}
// Machines/GetMachineMaintenanceDetail
// 获取设备保养信息
export async function GetMachineMaintenanceDetail(payload:any) {
    let res = await ajax.get('api/services/app/Machines/GetMachineMaintenanceDetail', {params:payload},false)
    return res.data.result
}